import { render, staticRenderFns } from "./configurazioneModificaPraticheDettaglio.vue?vue&type=template&id=3012f73e&"
import script from "./configurazioneModificaPraticheDettaglio.vue.ts?vue&type=script&lang=ts&"
export * from "./configurazioneModificaPraticheDettaglio.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports